import { systemAdmimUser } from './reducers';
export default systemAdmimUser;
